import { useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import LibModal from '../../../features/LibModal/LibModal';
import PageTitle from '../../../utils/PageTitle';
import { mkRelativeUrl } from '../../../utils/URL';
import AdminCreateNewUser from '../modals/AdminCreateNewUser';
import AdminsListProvider, { useAdminListInfo } from './AdminsListProvider';
import PageHeader from './Components/PageHeader';
import PageHeaderMobile from './Components/PageHeaderMobile';
import PageTable from './Components/PageTable';
import PageTableMobile from './Components/PageTableMobile';

function PageCont() {
    const navigate = useNavigate();
    const { adminListData, setParams, modalType, closeModal } = useAdminListInfo();

    // Search Params
    const [searchParams] = useSearchParams();
    const p = useMemo(
        () => ({
            status: searchParams.get('status') || '',
            q: searchParams.get('q') || '',
            'order-by': searchParams.get('order-by'),
            sort: searchParams.get('sort')
        }),
        [searchParams]
    );

    // Filter Handler
    const handleChangeFilterData = (e) => {
        const { name, value } = e.target;
        if (name) {
            navigate(mkRelativeUrl('/settings/admins', { ...p, [name]: value }));
        }
    };

    // For mobile view reset filter
    const onResetFilter = () => {
        navigate(mkRelativeUrl('/settings/admins', { q: '', status: '' }));
    };

    // Sorting Handler
    const handleSortingData = (column) => {
        navigate(
            mkRelativeUrl('/settings/admins', {
                ...p,
                'order-by': column,
                sort: p.sort === 'desc' ? 'asc' : 'desc'
            })
        );
    };

    useEffect(() => {
        setParams(p);
    }, [p, setParams]);
    return (
        <div className="customer_page inner_page_cont overflow-y-scroll">
            <LayoutProvider>
                <PageHeader
                    layout="default"
                    handleChangeFilterData={handleChangeFilterData}
                    p={p}
                />
                <PageHeaderMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    onResetFilter={onResetFilter}
                    onChangeHandler={handleChangeFilterData}
                    p={p}
                />
            </LayoutProvider>
            <LayoutProvider>
                <PageTable
                    layout="default"
                    data={adminListData}
                    handleSortingData={handleSortingData}
                    sortBy={p.sort}
                    sortedColumn={p['order-by']}
                />
                <PageTableMobile layout={['md', 'sm', 'xs', 'xxs']} data={adminListData} />
            </LayoutProvider>

            {modalType === 'create-new-admin' && (
                <LibModal title="Create Customer" setOpen={closeModal}>
                    <AdminCreateNewUser closeModal={closeModal} />
                </LibModal>
            )}
        </div>
    );
}

function AdminsListPage() {
    // set page title
    PageTitle(`Admins`);

    return (
        <AdminsListProvider>
            <PageCont />
        </AdminsListProvider>
    );
}

export default AdminsListPage;
